import { HttpStatusCode, type AxiosError } from 'axios';

type HandleAxiosErrorOnTooManyRequestsOptions = {
  error: AxiosError;
  handler: () => void;
};

export const handleAxiosErrorOnTooManyRequests = ({ error, handler }: HandleAxiosErrorOnTooManyRequestsOptions) => {
  if (error.response?.status === HttpStatusCode.TooManyRequests) {
    handler();
  }
};

export const getExpiredTimestamp = (seconds: number) => new Date().getTime() + seconds * 1000;
